// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-462462f8]:export{primaryColor:#0460a9;secondaryColor:#f1f1f1;accentColor:#c41230}.footer-bottom[data-v-462462f8]{background-color:var(--color-neutralLight)}.v-application p[data-v-462462f8]{margin-bottom:0}.footer-logo[data-v-462462f8]{height:60px}.footer-info-links li[data-v-462462f8]{display:inline;margin:0 5px}", ""]);
// Exports
module.exports = exports;
